/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchUpdateTilePlacements} from '../api'

export const useMutationBatchUpdateTilePlacements = createReactQueryMutationHook('batchUpdateTilePlacements', batchUpdateTilePlacements)
